<!--begin::Brand-->
<div class="brand flex-column-auto" id="kt_brand" [ngClass]="brandClasses">
  <ng-container *ngIf="asideSelfMinimizeToggle">
    <button class="brand-toggle btn btn-sm px-0" id="kt_aside_toggle">
      <span [inlineSVG]="'./assets/media/svg/icons/Navigation/Angle-double-left.svg'" cacheSVG="true" class="svg-icon svg-icon-xl"></span>
    </button>
  </ng-container>
</div>
<!--end::Brand-->

<!--begin::Aside Menu-->
<div class="aside-menu-wrapper flex-column-fluid" id="kt_aside_menu_wrapper">
  <ng-container *ngIf="disableAsideSelfDisplay">
    <!--begin::Header Logo-->
    <a routerLink="/">
      <img alt="Logo" [attr.src]="headerLogo" />
    </a>
    <!--end::Header Logo-->
  </ng-container>
  <!--begin::Menu Container-->
  <div id="kt_aside_menu" class="aside-menu" [ngClass]="asideMenuCSSClasses" data-menu-vertical="1"
    [attr.data-menu-scroll]="asideMenuScroll" [attr.data-menu-dropdown]="asideMenuDropdown"
    data-menu-dropdown-timeout="500">
    <!-- begin::Menu Nav -->
    <ul class="menu-nav" [ngClass]="ulCSSClasses">
      <!-- begin::1 Level -->
      <li class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active"
        [routerLinkActiveOptions]="{exact: true}">
        <a class="menu-link" [routerLink]="isBrowsing ? '/browsing' : '/'" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <i class="fa fa-home svg-icon menu-icon" aria-hidden="true" style="color: aqua;"></i>
          <span class="menu-text" style="color: aqua;">Dashboard</span>
        </a>
      </li>

      <li class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active" *ngIf="!isBrowsing && isOrgIdValid"
        [routerLinkActiveOptions]="{exact: true}">
        <a class="menu-link" routerLink="/data-use" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <i class="fas fa-shield-alt svg-icon menu-icon" aria-hidden="true" style="color: aqua;"></i>
          <span class="menu-text" style="color: aqua;">Data Access</span>
        </a>
      </li>

      <li class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active" *ngIf="!isBrowsing && isOrgIdValid"
        [routerLinkActiveOptions]="{exact: true}">
        <a class="menu-link" routerLink="/data-transfers" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <i class="fas fa-exchange-alt svg-icon menu-icon" aria-hidden="true" style="color: aqua;"></i>
          <span class="menu-text" style="color: aqua;">Data Transfers</span>
        </a>
      </li>

      <li class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active"
        [routerLinkActiveOptions]="{exact: true}">
        <a class="menu-link" [routerLink]="isBrowsing ? '/browsing/studies' : '/studies'" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <i class="fas fa-newspaper svg-icon menu-icon" aria-hidden="true" style="color: aqua;"></i>
          <span class="menu-text" style="color: aqua;">Studies</span>
        </a>
      </li>
      <li class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active"
        [routerLinkActiveOptions]="{exact: true}">
        <a class="menu-link" [routerLink]="isBrowsing ? '/browsing/data-objects' : '/data-objects'" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}">
          <i class="far fa-folder svg-icon menu-icon" aria-hidden="true" style="color: aqua;"></i>
          <span class="menu-text" style="color: aqua;">Data objects</span>
        </a>
      </li>
      <li *ngIf="isManager" class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active"
        [routerLinkActiveOptions]="{exact: true}">
        <a class="menu-link" routerLink="/people" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <i class="fas fa-users svg-icon menu-icon" aria-hidden="true" style="color: aqua;"></i>
          <span class="menu-text" style="color: aqua;">People</span>
        </a>
      </li>

      <!-- <li class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active"
        [routerLinkActiveOptions]="{exact: true}">
        <a class="menu-link" routerLink="/data-context" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}">
          <i class="fas fa-grip-lines-vertical svg-icon menu-icon" aria-hidden="true" style="color: aqua;"></i>
          <span class="menu-text" style="color: aqua;">Data Context</span>
        </a>
      </li> -->

      <!-- <li class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active"
        [routerLinkActiveOptions]="{exact: true}">
        <a class="menu-link" routerLink="/reports" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <i class="fas fa-clipboard-list svg-icon menu-icon" aria-hidden="true" style="color: aqua;"></i>
          <span class="menu-text" style="color: aqua;">Reports</span>
        </a>
      </li> -->
      <!-- end::1 Level -->
    </ul>
    <!-- end::Menu Nav -->
  </div>
  <!--end::Menu Container-->
</div>
<!--end::Aside Menu-->